import {
  AXES,
  GET_AXES,
  GET_AXES_ERROR,
  GET_AXES_SUCCESS,
  INSERT_NEW_AXE,
  INSERT_NEW_AXE_SUCCESS,
  INSERT_NEW_AXE_ERROR,
  DELETE_AXE,
  DELETE_AXE_SUCCESS,
  DELETE_AXE_ERROR,
  EDIT_AXE,
  EDIT_AXE_SUCCESS,
  EDIT_AXE_ERROR,
  GENERATE_PLATES,
  GENERATE_PLATES_SUCCESS,
  GENERATE_PLATES_ERROR,
} from 'redux/actions';

const initialStates = {
  axes: [],
  loading: false,
  error: '',
  success: '',
};

export default (state = initialStates, action) => {
  switch (action.type) {
    case GET_AXES:
    case INSERT_NEW_AXE:
    case EDIT_AXE:
    case DELETE_AXE:
    case GENERATE_PLATES:
      return {
        ...state,
        loading: true,
        success: '',
        error: '',
      };
    case AXES:
      return {
        ...state,
        axes: action.payload.axes,
      };
    case GET_AXES_SUCCESS:
    case INSERT_NEW_AXE_SUCCESS:
    case EDIT_AXE_SUCCESS:
    case DELETE_AXE_SUCCESS:
    case GENERATE_PLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: action.payload.message,
      };
    case GET_AXES_ERROR:
    case INSERT_NEW_AXE_ERROR:
    case EDIT_AXE_ERROR:
    case DELETE_AXE_ERROR:
    case GENERATE_PLATES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    default:
      return state;
  }
};
